import React from 'react';
import { Box } from '@mui/material';

// Wrapper component that mimics the popover styling for accurate measurement
export const PopoverContentWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <Box
      sx={{
        p: 2,
        // Match the popover paper styles
        maxWidth: '80vw',
        minWidth: 300,
        width: 'fit-content',
        // Don't apply maxHeight during measurement to get true content height
      }}
    >
      {children}
    </Box>
  );
};
